import React from 'react'
import {
  Bullet,
  Bullets,
  DocLink,
  Info,
  Page,
  Screenshot,
  Section,
} from '../../../components/CommandControlComponents'
import { Step } from '../../../components/DocsComponents'

const Dashboard = () => (
  <Page
    title="Control Room Dashboard"
    intro="The Command & Control dashboard is the entry point for live operations. It lists active and upcoming control rooms, summarises bed availability, and surfaces open incidents and recent command activity across rooms."
  >
    <Section title="Dashboard tabs">
      <Bullets>
        <Bullet>
          Open <DocLink url="/commandcontrol/controlroom" text="Command & Control > Control Rooms" /> to reach the dashboard.
        </Bullet>
        <Bullet><strong>Control Rooms</strong> — active control rooms you can enter, plus upcoming events that can have a room started.</Bullet>
        <Bullet><strong>Bed Management</strong> — a live summary of treatment locations and bed occupancy across active rooms.</Bullet>
        <Bullet><strong>Open Incidents</strong> — active incidents across your control rooms.</Bullet>
        <Bullet><strong>Recent Logs</strong> — recent command-log activity across rooms.</Bullet>
        <Bullet><strong>Custom Control Room</strong> — start a standalone room that is not linked to an event.</Bullet>
      </Bullets>
      <Screenshot url="command-control/dashboard.png">
        Command &amp; Control dashboard showing the tab bar, active control
        rooms, and upcoming events.
      </Screenshot>
    </Section>

    <Section title="Starting a control room for an event">
      <Step number={1} title="Find the event">
        Upcoming events appear on the Control Rooms tab with their location
        and running times.
      </Step>
      <Step number={2} title="Start or launch">
        If the event has no room yet, choose Start Control Room and confirm.
        If a room already exists, Launch Control Room takes you straight in —
        and, for commanders, reopens the room if it had been closed.
      </Step>
      <Step number={3} title="Enter an active room">
        Active control rooms show as cards with an Enter Control Room button.
      </Step>
      <Info>
        Who can do this? Starting (or reopening) a control room is
        Commander-only — the Start button is hidden for other roles, and the
        server enforces it. Any CAD role can enter a room that is already
        running.
      </Info>
    </Section>

    <Section title="Custom control rooms">
      <Bullets>
        <Bullet>Use the Custom Control Room tab to start a standalone operational room with its own title — useful for ad-hoc operations that are not planned events.</Bullet>
        <Bullet>If an active room already exists with the same title, the dashboard points you to it instead of creating a duplicate.</Bullet>
        <Bullet>Non-commanders see an explanation instead of the form: ask a commander to open the room, then join it from the dashboard.</Bullet>
      </Bullets>
    </Section>

    <Section title="Cross-room visibility">
      <Bullets>
        <Bullet>Open Incidents and Recent Logs give duty managers a quick view across all active rooms without entering each one.</Bullet>
        <Bullet>Bed Management summarises treatment locations, waiting patients, and occupancy so patient flow can be balanced between centres.</Bullet>
      </Bullets>
    </Section>
  </Page>
)

export default Dashboard
